import React from "react";
import Sidebar from "@/components/Sidebar";
import NotificationsBell from "@/components/NotificationsBell";

export default function Shell({ children, title, subtitle, actions }) {
  return (
    <div className="flex bg-slate-50 min-h-screen font-body">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="bg-white border-b border-blue-100 px-8 py-6 flex items-start justify-between gap-4">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-blue-950 font-heading" data-testid="page-title">
              {title}
            </h1>
            {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">
            <NotificationsBell />
            {actions}
          </div>
        </header>
        <div className="p-6 sm:p-8">{children}</div>
      </main>
    </div>
  );
}
